import { ApiError } from "@vana/core";

export class CloseDayError extends ApiError {}
export class GetDayCloseError extends ApiError {}
